import {
  HighlightedText,
  MainHeading,
  Subheading,
} from "components/misc/Headings";

import AnimationRevealPage from "helpers/AnimationRevealPage";
import FooterPage from "components/Footer";
import React from "react";
import { SectionDescription } from "components/misc/Typography";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-1.svg";
import SEO from "components/seo/SEO"
//eslint-disable-next-line
import styled from "styled-components";
import tw from "twin.macro";

const Container = tw.section`mt-32 relative max-w-screen-xl mx-auto`;
const HorizontalLine = tw.hr`border-gray-100 my-5`;
const Wrapper = tw.section`mt-10`;

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;

function ImpressumPage() {
  return (
    <AnimationRevealPage>
      <SEO
        title="Impressum - Weg2De"
        description="Impressum - Weg2De - German Online Group Course | Learn German Online | German Individual Courses | German for Professionals "
        name="Weg2De"
        type=""
      />
      <Container>
        <MainHeading>
          Impressum/<HighlightedText>Imprint</HighlightedText>
        </MainHeading>
        <Wrapper>
          <SectionDescription>Angaben gemäß §5 TMG:</SectionDescription>
          <address>
         
              <b>Weg2De</b>
              <br />
              Juliusstraße, 11
              <br />
              42105 Wuppertal 
              <br />
              Deutschland
          </address>
          <HorizontalLine />
          <Subheading>Vertreten durch: </Subheading>
          <SectionDescription>Ishaq Kokumo <strong>(Inhaber)</strong></SectionDescription>
          
          {/*
          <Subheading>Handelsregister</Subheading>
          <SectionDescription>
            <strong>Eingetragen in:</strong> Nigeria – Corporate Affairs Commission (CAC)
          </SectionDescription>
          <SectionDescription><strong>Registernummer:</strong> RC7316755</SectionDescription>*/}
          <HorizontalLine />
          <Subheading>Kontakt</Subheading>
          <SectionDescription><strong>E-Mail: </strong>info@weg2de.com</SectionDescription>
          <HorizontalLine />

          <Subheading>Kleinunternehmerregelung</Subheading>
          <SectionDescription>Gemäß § 19 Abs. 1 UStG nicht umsatzsteuerpflichtig</SectionDescription>
          <HorizontalLine />
          <SectionDescription>
            Dieses Impressum gilt auch für die Angebote auf Facebook, Instagram, TikTok,
            LinkedIn, Youtube und X
          </SectionDescription>
          <Subheading>Haftungsausschluss</Subheading>
          <SectionDescription>
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine
            Haftung für die Inhalte externer Links. Für den Inhalt der
            verlinkten Seiten sind ausschließlich deren Betreiber
            verantwortlich.
          </SectionDescription>
        </Wrapper>
        <DecoratorBlob1 />
      </Container>
      <FooterPage />
    </AnimationRevealPage>
  );
}

export default ImpressumPage;
